import { useEffect } from "react";
import { Navigate, useSearchParams } from "react-router";
import { t } from "../i18n";
import { safeReturnTo } from "../lib";
import { useSession } from "../session";
import { AuthCard } from "./AuthCard";
import { LoginButtons } from "./LoginButtons";

/** Which wording the page shows - by where `return_to` leads: a download link, the checkout, or anywhere else. */
export function signInKind(returnTo: string | null): "download" | "subscribe" | "generic" {
  if (!returnTo) return "generic";
  if (returnTo.startsWith("/api/v1/downloads/")) return "download";
  if (returnTo === "/subscribe" || returnTo.startsWith("/subscribe?")) return "subscribe";
  return "generic";
}

const TEXTS = {
  download: { title: "signin.downloadTitle", text: "signin.downloadText" },
  subscribe: { title: "signin.subscribeTitle", text: "signin.subscribeText" },
  generic: { title: "signin.title", text: "signin.text" },
} as const;

/** Sign in, then go on to `return_to` (a server route or a page, full navigation); the wording follows the target. */
export function SignInPage() {
  const { me } = useSession();
  const [search] = useSearchParams();
  const returnTo = safeReturnTo(search.get("return_to"));
  const texts = TEXTS[signInKind(returnTo)];

  useEffect(() => {
    if (me && returnTo) window.location.assign(returnTo);
  }, [me, returnTo]);

  if (me === undefined) return null;
  if (me) return returnTo ? null : <Navigate to="/connections" replace />;

  return (
    <AuthCard>
      <h1>{t(texts.title)}</h1>
      <p className="auth-text">{t(texts.text)}</p>
      <LoginButtons returnTo={returnTo ?? undefined} />
    </AuthCard>
  );
}
